import { Image, Alert, Form, Button } from "antd";
import { useLocation, useNavigate, Link } from "react-router-dom";
import LoginTemplate from "../../templates/LoginTemplate";
import { useState } from "react";
import { InputField, InputPassword } from "../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { login } from "./ducks/services";
import { AxiosError, AxiosResponse } from "axios";
import { ErrorMessage } from "../../atoms/Toasts/ErrorMessage";
import { SuccessIcon } from "../../atoms/CustomIcons";
interface FormValues {
  email: string;
  password: string;
}

export default function Login() {
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const location = useLocation();
  const navigate = useNavigate();
  const clearState = () => {
    navigate({ pathname: window.location.pathname }, { replace: true });
  };

  const onSubmit = (val: FormValues) => {
    setLoading(true);
    login(val)
      .then((res: AxiosResponse) => {
        if (res?.data?.success) {
          localStorage.setItem("@lsToken", JSON.stringify(res?.data?.token));
          window.location.assign("/");
        }
      })
      .catch((e: unknown) => {
        setLoading(false);
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          ErrorMessage("Something went wrong");
        }
      });
  };

  console.log("App Version 0.0.6");
  return (
    <LoginTemplate loading={loading}>
      <div className="loginForm">
        <div className="loginLogo">
          <Image src="/images/login/logo.svg" alt="Logo" preview={false} />
        </div>

        <h1> Welcome to LandScaling </h1>
        <p> Enter your account credentials to get started. </p>

        {location?.state?.name === "reset" && (
          <div className="alertWrapper" style={{ marginBottom: "20px" }}>
            <Alert
              message="A link to reset your password has been emailed to you."
              type="success"
              onClose={clearState}
              showIcon
              closable
              icon={<SuccessIcon />}
            />
          </div>
        )}

        {location?.state?.name === "update" && (
          <div className="alertWrapper" style={{ marginBottom: "20px" }}>
            <Alert
              message="Your password was reset. You can log in using your new password"
              type="success"
              onClose={clearState}
              showIcon
              closable
            />
          </div>
        )}

        <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
          <InputField
            fieldName="email"
            label="Email"
            control={control}
            defaultValue=""
            iProps={{
              placeholder: "Enter email",
              autoComplete: "Email",
            }}
            isRequired
            rules={{
              required: "Email is required.",
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Incorrect email address.",
              },
            }}
            validate={errors.email && "error"}
            validMessage={errors.email && errors.email.message}
          />
          <InputPassword
            fieldName="password"
            label="Password"
            control={control}
            defaultValue=""
            iProps={{
              placeholder: "Enter password",
              autoComplete: "Password",
            }}
            isRequired
            rules={{
              required: "Password is required.",
            }}
            validate={errors.password && "error"}
            validMessage={errors.password && errors.password.message}
          />
          <div className="forgotPass">
            <Link to="/forgot-password"> Forgot password? </Link>
          </div>
          <Button
            htmlType="submit"
            type="primary"
            // disabled={!isDirty || !isValid || !errors.email || !errors.password}
          >
            Log in
          </Button>
          <div className="cantLogin">
            <p>
              Can't log in? Please,{" "}
              <a href="mailto:support@landscaling.com">
                contact our support team.
              </a>
            </p>
          </div>
        </Form>
      </div>
    </LoginTemplate>
  );
}
